module.exports = __webpack_public_path__ + "86bc199c1d85ca4d2eff50ce5ac97fbf.ttf";